import ECompareMode from 'enums/ECompareMode';

export enum EGridLayout {
  Row = 'Single Row',
  Grid = '2 x 2 Grid',
  Overlay = 'Overlay',
}

export const gridColumnGap = 5;
export const gridRowGap = 12;

export const baseGridStyles = {
  height: '100%',
  width: '100%',
  display: 'grid',
  overflow: 'hidden',
};

export const compareModeMap: Record<string, ECompareMode> = {
  [ECompareMode.Grid]: ECompareMode.Grid,
  [ECompareMode.Row]: ECompareMode.Row,
};
